export default "__VITE_ASSET__COqKB_Na__"